__turbopack_export_value__({
  "body-logo-18": "ActionButton-module-scss-module__1vzHnG__body-logo-18",
  "body-text-12": "ActionButton-module-scss-module__1vzHnG__body-text-12",
  "body-text-14": "ActionButton-module-scss-module__1vzHnG__body-text-14",
  "body-text-16": "ActionButton-module-scss-module__1vzHnG__body-text-16",
  "body-text-18": "ActionButton-module-scss-module__1vzHnG__body-text-18",
  "body-text-20": "ActionButton-module-scss-module__1vzHnG__body-text-20",
  "body-text-24": "ActionButton-module-scss-module__1vzHnG__body-text-24",
  "body-text-24-2": "ActionButton-module-scss-module__1vzHnG__body-text-24-2",
  "body-text-heading-2": "ActionButton-module-scss-module__1vzHnG__body-text-heading-2",
  "body-text-heading-3": "ActionButton-module-scss-module__1vzHnG__body-text-heading-3",
  "body-text-medium-14": "ActionButton-module-scss-module__1vzHnG__body-text-medium-14",
  "body-text-medium-16": "ActionButton-module-scss-module__1vzHnG__body-text-medium-16",
  "body-text-medium-18": "ActionButton-module-scss-module__1vzHnG__body-text-medium-18",
  "body-text-medium2-18": "ActionButton-module-scss-module__1vzHnG__body-text-medium2-18",
  "body-text2-14": "ActionButton-module-scss-module__1vzHnG__body-text2-14",
  "body-text2-16": "ActionButton-module-scss-module__1vzHnG__body-text2-16",
  "button": "ActionButton-module-scss-module__1vzHnG__button",
  "button-primary-text": "ActionButton-module-scss-module__1vzHnG__button-primary-text",
  "button-text": "ActionButton-module-scss-module__1vzHnG__button-text",
  "button2-text": "ActionButton-module-scss-module__1vzHnG__button2-text",
  "button_disabled": "ActionButton-module-scss-module__1vzHnG__button_disabled",
  "button_line": "ActionButton-module-scss-module__1vzHnG__button_line",
  "button_purple": "ActionButton-module-scss-module__1vzHnG__button_purple",
  "card-shadow": "ActionButton-module-scss-module__1vzHnG__card-shadow",
  "effect-menu": "ActionButton-module-scss-module__1vzHnG__effect-menu",
  "header-1": "ActionButton-module-scss-module__1vzHnG__header-1",
  "main-container": "ActionButton-module-scss-module__1vzHnG__main-container",
  "main-footer-container": "ActionButton-module-scss-module__1vzHnG__main-footer-container",
  "main-header-container": "ActionButton-module-scss-module__1vzHnG__main-header-container",
  "txt-12-bold": "ActionButton-module-scss-module__1vzHnG__txt-12-bold",
  "txt-14-bold": "ActionButton-module-scss-module__1vzHnG__txt-14-bold",
  "txt-14-bold-caps": "ActionButton-module-scss-module__1vzHnG__txt-14-bold-caps",
  "txt-14-med": "ActionButton-module-scss-module__1vzHnG__txt-14-med",
  "txt-16-bold": "ActionButton-module-scss-module__1vzHnG__txt-16-bold",
  "txt-16-med": "ActionButton-module-scss-module__1vzHnG__txt-16-med",
  "txt-18-bold": "ActionButton-module-scss-module__1vzHnG__txt-18-bold",
  "txt-18-medium": "ActionButton-module-scss-module__1vzHnG__txt-18-medium",
  "txt-18-medium-24": "ActionButton-module-scss-module__1vzHnG__txt-18-medium-24",
  "txt-24-semi": "ActionButton-module-scss-module__1vzHnG__txt-24-semi",
});
